<app-page-loader *ngIf="loading"></app-page-loader>

<ng-container *ngIf="!loading">
  <!-- Customer goals and what they are made of -->
  <section class="or-section">
    <header class="or-head">
      <div>
        <h6>{{ I18N + ".goalsTitle" | translate }}</h6>
        <p class="or-hint">{{ I18N + ".goalsHint" | translate }}</p>
      </div>
      <div class="or-actions">
        <button nbButton size="small" status="basic" [disabled]="!!busy || !view.goals.length" (click)="suggest()"
                [nbSpinner]="busy === 'suggest'">{{ I18N + ".suggest" | translate }}</button>
        <label class="or-file" [class.is-busy]="busy === 'import'">
          <input type="file" accept=".csv,.txt,text/csv" (change)="importFile($event)" [disabled]="!!busy" />
          <span>{{ I18N + ".import" | translate }}</span>
        </label>
        <button nbButton size="small" status="primary" [disabled]="!!busy" (click)="startAdd('goal')">{{ I18N + ".addGoal" | translate }}</button>
      </div>
    </header>

    <form class="or-form" *ngIf="adding === 'goal'" (ngSubmit)="saveDraft()">
      <textarea nbInput fullWidth rows="2" name="d" [(ngModel)]="draft.description" data-enter-ignore
                [placeholder]="I18N + '.goalPlaceholder' | translate"></textarea>
      <nb-select size="small" name="b" [(ngModel)]="draft.bloom_level" [placeholder]="I18N + '.bloom' | translate">
        <nb-option value="">—</nb-option>
        <nb-option *ngFor="let b of bloomLevels" [value]="b">{{ "components.competency.bloom." + b | translate }}</nb-option>
      </nb-select>
      <span class="or-form__buttons">
        <button nbButton size="small" status="basic" type="button" (click)="adding = null">{{ I18N + ".cancel" | translate }}</button>
        <button nbButton size="small" status="primary" type="submit" [disabled]="busy === 'add'" [nbSpinner]="busy === 'add'">{{ I18N + ".save" | translate }}</button>
      </span>
    </form>

    <p class="or-hint" *ngIf="!view.goals.length">{{ I18N + ".noGoals" | translate }}</p>

    <details class="al-disclosure" *ngFor="let g of view.goals; trackBy: trackKey" [class.is-retired]="!g.active">
      <summary>
        <span class="or-goal">{{ g.text }}</span>
        <span class="or-chips">
          <span class="al-status-chip al-status-chip--neutral">{{ I18N + ".origin." + g.origin | translate }}</span>
          <span class="al-status-chip" [ngClass]="g.confirmed.length ? 'al-status-chip--accept' : 'al-status-chip--warning'">
            {{ I18N + ".linked" | translate: { count: g.confirmed.length } }}
          </span>
          <span *ngIf="g.proposed.length" class="al-status-chip al-status-chip--info">{{ I18N + ".proposed" | translate: { count: g.proposed.length } }}</span>
        </span>
      </summary>
      <ul class="or-links">
        <li *ngFor="let l of g.confirmed; trackBy: trackKey">
          <span class="or-links__text">{{ l.text }}</span>
          <button nbButton ghost size="tiny" status="basic" [disabled]="!!busy" (click)="link(g, l.key, 'rejected')">{{ I18N + ".unlink" | translate }}</button>
        </li>
        <li *ngFor="let l of g.proposed; trackBy: trackKey" class="is-proposed">
          <span class="or-links__text">{{ l.text }}<small *ngIf="l.score"> · {{ I18N + ".similarity" | translate: { value: l.score } }}</small></span>
          <span class="or-links__decide">
            <button nbButton ghost size="tiny" status="basic" [disabled]="!!busy" (click)="link(g, l.key, 'rejected')">{{ I18N + ".reject" | translate }}</button>
            <button nbButton size="tiny" status="primary" [disabled]="!!busy" (click)="link(g, l.key, 'confirmed')">{{ I18N + ".confirm" | translate }}</button>
          </span>
        </li>
      </ul>
      <div class="or-addlink" *ngIf="g.candidates.length">
        <nb-select size="small" [(selected)]="linkPick[g.key]" [placeholder]="I18N + '.pickObjective' | translate">
          <nb-option *ngFor="let c of g.candidates" [value]="c.key">{{ c.text }}</nb-option>
        </nb-select>
        <button nbButton size="small" status="primary" [disabled]="!linkPick[g.key] || !!busy" (click)="link(g, linkPick[g.key], 'confirmed')">
          {{ I18N + ".addLink" | translate }}
        </button>
      </div>
      <div class="or-retire" *ngIf="g.origin !== 'curriculum'">
        <button nbButton ghost size="tiny" status="basic" [disabled]="!!busy" (click)="setActive(g.key, !g.active)">
          {{ (g.active ? I18N + ".retire" : I18N + ".restore") | translate }}
        </button>
      </div>
    </details>
  </section>

  <!-- The course's learning objectives -->
  <section class="or-section">
    <header class="or-head">
      <div>
        <h6>{{ I18N + ".objectivesTitle" | translate }}</h6>
        <p class="or-hint">{{ I18N + ".objectivesHint" | translate }}</p>
      </div>
      <div class="or-actions">
        <button nbButton size="small" status="primary" [disabled]="!!busy" (click)="startAdd('objective')">{{ I18N + ".addObjective" | translate }}</button>
      </div>
    </header>

    <form class="or-form" *ngIf="adding === 'objective'" (ngSubmit)="saveDraft()">
      <textarea nbInput fullWidth rows="2" name="d" [(ngModel)]="draft.description" data-enter-ignore
                [placeholder]="I18N + '.objectivePlaceholder' | translate"></textarea>
      <nb-select size="small" name="c" [(ngModel)]="draft.chapter_id" [placeholder]="I18N + '.chapter' | translate">
        <nb-option value="">{{ I18N + ".noChapter" | translate }}</nb-option>
        <nb-option *ngFor="let ch of chapters" [value]="ch.id">{{ ch.title }}</nb-option>
      </nb-select>
      <nb-select size="small" name="b" [(ngModel)]="draft.bloom_level" [placeholder]="I18N + '.bloom' | translate">
        <nb-option value="">—</nb-option>
        <nb-option *ngFor="let b of bloomLevels" [value]="b">{{ "components.competency.bloom." + b | translate }}</nb-option>
      </nb-select>
      <nb-select size="small" name="q" [(ngModel)]="draft.dqr_area" [placeholder]="I18N + '.dqr' | translate">
        <nb-option value="">—</nb-option>
        <nb-option *ngFor="let a of dqrAreas" [value]="a">{{ "components.competency.dqr." + a | translate }}</nb-option>
      </nb-select>
      <span class="or-form__buttons">
        <button nbButton size="small" status="basic" type="button" (click)="adding = null">{{ I18N + ".cancel" | translate }}</button>
        <button nbButton size="small" status="primary" type="submit" [disabled]="busy === 'add'" [nbSpinner]="busy === 'add'">{{ I18N + ".save" | translate }}</button>
      </span>
    </form>

    <ul class="or-objectives">
      <li *ngFor="let o of view.objectives; trackBy: trackKey" [class.is-retired]="!o.active">
        <span class="or-objectives__text">
          {{ o.text }}
          <small>
            <span class="al-status-chip" [ngClass]="o.source === 'lecturer' ? 'al-status-chip--info' : 'al-status-chip--neutral'">
              {{ I18N + ".source." + o.source | translate }}
            </span>
            <ng-container *ngIf="o.chapter"> · {{ o.chapter }}</ng-container>
            <ng-container *ngIf="o.bloom"> · {{ "components.competency.bloom." + o.bloom | translate }}</ng-container>
          </small>
        </span>
        <nb-select size="tiny" class="or-dqr" [selected]="o.dqr || ''" (selectedChange)="setDqr(o.key, $event)"
                   [disabled]="!!busy || !o.active" [attr.aria-label]="I18N + '.dqr' | translate">
          <nb-option value="">{{ I18N + ".dqrNone" | translate }}</nb-option>
          <nb-option *ngFor="let a of dqrAreas" [value]="a">{{ "components.competency.dqr." + a | translate }}</nb-option>
        </nb-select>
        <button *ngIf="o.source === 'lecturer'" nbButton ghost size="tiny" status="basic" [disabled]="!!busy"
                (click)="setActive(o.key, !o.active)">
          {{ (o.active ? I18N + ".retire" : I18N + ".restore") | translate }}
        </button>
      </li>
    </ul>
  </section>
</ng-container>
